module.exports = __webpack_public_path__ + "static/img/shebei.88bd4ff1.png";